<template>
  <v-toolbar
    tag="div"
    dense
    slot="extension"
    color="transparent"
    elevation="0"
    align-with-title
    light
  >
    <v-breadcrumbs :items="filteredBreadcrumbs" class="crumbs py-3 px-0" />
  </v-toolbar>
</template>
<script>
import { mapGetters } from 'vuex'
import HipotekaMap from '../../hipoteka/hipotekaMap'

export default {
  name: 'AppBreadcrumbs',
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['objektasID', 'hipotekaTipas']),
    filteredBreadcrumbs() {
      return this.breadcrumbs.filter(item => {
        if (item.text !== 'undefined') {
          return item ?? ''
        }
      })
    },
    breadcrumbs() {
      const { matched } = this.$route
      return matched.map((route, index) => {
        let to =
          index === matched.length - 1
            ? this.$route.path
            : route.path || route.redirect
        let text = this.$vuetify.lang.t('' + route.meta.title)
        to = this.checkVariables(to)
        text = this.checkVariables(text)
        return {
          text: text,
          to: to,
          exact: false,
          disabled: false,
        }
      })
    },
    hipotekaTitle() {
      return this.hipotekaTipas
        ? HipotekaMap['hipotekaTipas'][this.hipotekaTipas]
          ? HipotekaMap['hipotekaTipas'][this.hipotekaTipas].title
          : this.hipotekaTipas
        : ''
    },
    turtasTitle() {
      const key = Object.keys(HipotekaMap['turtasTekstas']).find(e =>
        this.hipotekaTipas.includes(e)
      )
      return key ? HipotekaMap['turtasTekstas'][key].title : null
    },
    prievoleTitle() {
      const key = Object.keys(HipotekaMap['prievoleTekstas']).find(e =>
        this.hipotekaTipas.includes(e)
      )
      return key ? HipotekaMap['prievoleTekstas'][key].tab : null
    },
    salyginisTitle() {
      const key = Object.keys(HipotekaMap['salyginisTekstas']).find(e =>
        this.hipotekaTipas.includes(e)
      )
      return key ? HipotekaMap['salyginisTekstas'][key].tab : null
    },
  },
  methods: {
    checkVariables(text) {
      if (typeof text !== 'string') {
        return text
      }
      text = text.replace(':objektasID', this.objektasID)
      text = text.replace(':hipotekaTipas', this.hipotekaTitle)
      text = text.replace(':turtasTitle', this.turtasTitle)
      text = text.replace(':prievoleTitle', this.prievoleTitle)
      text = text.replace(':salyginisTitle', this.salyginisTitle)
      text = text.replace(':prasymasID', this.prasymasID)
      text = text.replace(':prasymasTipas', this.prasymasTipas)
      return text === 'null' ? '' : text
    },
  },
  created() {},
}
</script>

<style lang="scss">
.crumbs {
  font-family: 'Open Sans';
  font-weight: normal;
  li {
    font-size: 12px !important;
  }
}
</style>
